export default {
  TITLE: {
    title: 'Privacy Policy and Consent to Treat'
  },
  NO_DATA: {
    severity: 'info' as 'info',
    title: 'This provider has no "Privacy Practices and Consent to Treat" document.'
  }
};
